import React, {useState, useEffect} from 'react';
import {Link} from 'react-router-dom';
import './point_subcategories.scss';
import axios from '../../axios'
import Search from "../Search/Search";
import ReactPaginate from "react-paginate";
import Loader from "../Loader/Loader";
import {toast} from "react-toastify";


const PointSubCategories = () => {
    const [pointsubcategories, setpointsubcategories] = useState([]);
    const [filtered, setFiltered] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    // pagination
    const [pageNumber, setPageNumber] = useState(0);
    const productsPerPage = 8;
    const productsPerList = 50;
    const pagesVisited = pageNumber * productsPerPage;
    let displayUsers = [];
    const pageCount = Math.ceil(filtered.length / productsPerPage);

    const changePage = ({selected}) => {
        console.log(selected)
        setPageNumber(selected);
    };

    useEffect(() => {

        axios.get('point-subcategories/all').then((res) => {
            setpointsubcategories(res?.data);
            setFiltered(res?.data)
            setIsLoading(false)
        }).catch((err) => {
            toast.error('Something went wrong!')
            console.log(err)
        });
    }, [])

    return (
        <div className='point_subcategories p-5 text-left'>
            <div className='page-title'>
                <h1>Sub Category Management</h1> <br/>
            </div>

            <div className='row search-add'>
            <Search data={pointsubcategories} filtered={setFiltered} setPageNumber={setPageNumber}/>
                <Link to='/point-subcategories/add' className='myButton'>Add New Sub Category</Link>
            </div>
            <div className='row'>
            <div className='row list-description mb-2'>
                                    <div className='col-1'>Id</div>
                                    <div className='col-3'>Name</div>
                                    <div className='col-3'>Category</div>
                                    <div className='col-3 hideme'>Status</div>
                                    <div className='col-1 hideme'>Edit</div>
                                    <div className='col-1 hideme'>Delete</div>
                                </div>
                {
                    isLoading ? <Loader/> :
                        displayUsers = filtered?.slice
                        (pagesVisited, pagesVisited + productsPerPage)?.map
                        (filtered => {
                                return (<div className='listimi showme' key={filtered.id}>
                                        <div className='row '>
                                            <div className='col-1'>{filtered.id} </div>
                                            <div className='col-3'>{filtered.name} </div>
                                            <div className='col-3'>{filtered.category_name} </div>
                                            <div className='col-3'>{filtered.active ? 'Active' : 'Pasive'} </div>
                                            <div className='col-1 hideme'><Link className={'fa fa-edit'}
                                                                                to={'/point-subcategories/edit/' + filtered.id}></Link>
                                            </div>
                                            <div className='col-1 hideme'><Link className={'fa fa-trash'}
                                                                                to={'/point-subcategories/delete/' + filtered.id}></Link>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        )
                }
            </div>
            <div className="row mt-5">
                <div className="col-12">
                    {(pointsubcategories.length >= productsPerPage) ?
                        <ReactPaginate
                            previousLabel={"Previous"}
                            nextLabel={"Next"}
                            pageCount={pageCount}
                            onPageChange={changePage}
                            containerClassName={"paginationBttns"}
                            previousLinkClassName={"previousBttn"}
                            nextLinkClassName={"nextBttn"}
                            disabledClassName={"paginationDisabled"}
                            activeClassName={"paginationActive"}
                        /> : ''
                    }
                </div>
            </div>
        </div>
    )

}

export default PointSubCategories;